// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 创建用户 POST /apiAdmin/user */
export async function userControllerCreateUser(
  body: API.CreateUserDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataUserDataDtoDto>("/apiAdmin/user", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据ID获取用户 GET /apiAdmin/user/${param0} */
export async function userControllerGetUserById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.UserControllerGetUserByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataUserWithRolesDtoDto>(
    `/apiAdmin/user/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新用户 PUT /apiAdmin/user/${param0} */
export async function userControllerUpdateUser(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.UserControllerUpdateUserParams,
  body: API.UpdateUserDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataUserDataDtoDto>(`/apiAdmin/user/${param0}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 删除用户 DELETE /apiAdmin/user/${param0} */
export async function userControllerDeleteUser(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.UserControllerDeleteUserParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/user/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 修改用户密码 PUT /apiAdmin/user/${param0}/password */
export async function userControllerChangePassword(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.UserControllerChangePasswordParams,
  body: API.ChangePasswordDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/user/${param0}/password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 分配角色 POST /apiAdmin/user/${param0}/roles */
export async function userControllerAssignRoles(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.UserControllerAssignRolesParams,
  body: API.AssignRolesDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/user/${param0}/roles`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户列表（分页） POST /apiAdmin/user/list */
export async function userControllerGetUserList(
  body: API.QueryUserDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataUserWithRolesDtoPageDto>("/apiAdmin/user/list", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
